import { MenuItem, Select, styled } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { useCommonTranslation } from '../../hooks/useCommonTranslation';

const StyledSelectedText = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 14,
}));

const MultiSelectEditComponent = (props: any) => {
  const t = useCommonTranslation();
  const { id, value, field, colDef } = props;
  const options = colDef.valueOptions;
  const apiRef = useGridApiContext();

  const handleChange = (event: any) => {
    const eventValue = event.target.value;
    const newValue =
      typeof eventValue === 'string' ? value.split(',') : eventValue;
    apiRef.current.setEditCellValue({
      id,
      field,
      value: newValue.filter((x: string) => x !== ''),
    });
  };

  return (
    <Select
      multiple
      value={value}
      onChange={handleChange}
      sx={{ width: '100%' }}
      displayEmpty={!!props.placeholder}
      renderValue={(selectedArray?: string[]) => {
        if (!selectedArray || selectedArray.length === 0) {
          return props.placeholder ? (
            <StyledSelectedText>{props.placeholder}</StyledSelectedText>
          ) : (
            <></>
          );
        }
        const selectedString = selectedArray
          .map((selectedOption) => {
            const matchingOption = options.find(
              (option: any) => colDef.getOptionValue(option) === selectedOption,
            );
            if (matchingOption) {
              return colDef.getOptionLabel(matchingOption);
            }
            return '';
          })
          .join(', ');
        if (props.placeholder) {
          return <StyledSelectedText>{selectedString}</StyledSelectedText>;
        }
        return selectedString;
      }}>
      {options.map((option: any) => {
        const value = colDef.getOptionValue(option);
        const label = colDef.getOptionLabel(option);
        return (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export const MultiSelectEditCell = (params: any) => (
  <MultiSelectEditComponent {...params} />
);
